(function($) {

    $.fn.collapsibleFilters = function (options) {
        // build main options before element iteration
        var opts = $.extend(true, {}, $.fn.collapsibleFilters.defaults, options);

        return this.each(function () {
            var $this = $(this);
            // build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            $this.wrap('<div class="expanded-filters"></div>');
            var $expandedFilters = $this.closest('.expanded-filters');

            $expandedFilters.wrap('<div class="collapsible-filters"></div>');
            var $collapsibleFilters = $this.closest('.collapsible-filters');

            var $collapsedFilters = $('<div class="collapsed-filters"></div>');
            $collapsibleFilters.append($collapsedFilters);


            var $collapseButton = $('<button type="button" class="button collapse-button button-icon button-icon-only" data-icon="ui-icon-msxi-collapse">' + translate(eOpts['hide-filters-text']) + '</button>');
            var $expandButton = $('<button type="button" class="button expand-button button-icon button-icon-only" data-icon="ui-icon-msxi-filter">' + translate(eOpts['show-filters-text']) + '</button>');

            $collapsedFilters.append($expandButton);
            $expandedFilters.append($collapseButton);

            $collapseButton.msxibutton();
            $expandButton.msxibutton();

            function expand() {
                $collapsedFilters.hide();
                $expandedFilters.show();
            }

            function collapse() {
                $expandedFilters.hide();
                $collapsedFilters.show();
            }

            $expandButton.on('click', expand);
            $collapseButton.on('click', collapse);

            if (eOpts.collapsed) {
                collapse();
            }
            else {
                expand();
            }

            $this.removeClass('off-screen');

            loadCollapsedFilters();
            $this.on('submitted', loadCollapsedFilters);

            function loadCollapsedFilters() {
                $collapsedFilters.find('.collapsed-filter').remove();
                var i = 0;
                $expandedFilters.find('.form-row').each(function () {
                    var $formRow = $(this);
                    var value = getFormRowValue($formRow);
                    if (value) {
                        var label = getFormRowLabel($formRow);
                        var $collapsedFilter = $('<span class="collapsed-filter"></span>');
                        $collapsedFilter.append($('<label>' + label + ':' + '</label>'));
                        $collapsedFilter.append(" ");
                        $collapsedFilter.append($('<span class="value">' + value + '</span>'));
                        $collapsedFilters.append($collapsedFilter);
                        $collapsedFilters.append(" ");
                        i++;
                    }
                });
                if (i === 0) {
                    $collapsedFilters.append('<span class="collapsed-filter no-filters">' + translate(eOpts['no-filters-text']) + '</span>');
                }
            }

        });
    };

    function getFormRowLabel($formRow) {
        var label = $.trim($formRow.find('> label').text());
        label = label.replace('\*', '');
        return label;
    }

    function getFormRowValue($formRow) {
        if ($formRow.find('.form-number-range').size() > 0) {
            return getNumberRangeValue($formRow);
        }
        else if ($formRow.find('.form-input-text, .form-input-slider, .form-input-spinner, .form-input-spinner-and-slider, .form-textarea').size() > 0) {
            return getTextValue($formRow);
        }
        else if ($formRow.find('.form-select').size() > 0) {
            return getSelectValue($formRow);
        }
        else if ($formRow.find('.form-dropdowntree').size() > 0) {
            return getTreeValue($formRow);
        }
        else if ($formRow.find('.form-date-range').size() > 0) {
            return getDateRangeValue($formRow);
        }
        else if ($formRow.find('.form-date').size() > 0) {
            return getDateValue($formRow);
        }
        else if ($formRow.find('.form-time-period-for-date').size() > 0) {
            return getDateAndTimeRangeValue($formRow);
        }
        else if ($formRow.find('.form-datetime').size() > 0) {
            return getDateTimeValue($formRow);
        }
        else if ($formRow.find('.form-radiobuttons-boolean').size() > 0) {
            return getRadiobuttonsBooleanValue($formRow);
        }
        else if ($formRow.find('.form-checkboxes, .form-radiobuttons').size() > 0) {
            return getCheckboxesOrRadiobuttonsValue($formRow);
        }
        else if ($formRow.find('.form-checkbox').size() > 0) {
            return getCheckboxValue($formRow);
        }
        else if ($formRow.find('.form-text').size() > 0) {
            return getTextValue($formRow);
        }
        return null;
    }

    function getSelectValue($formRow) {
        if ($formRow.find('select[multiple]').size() == 0) {
            return $.trim($formRow.find(':input option:selected[value!=""]').text());
        }
        else {
            var result = null;

            if($formRow.find(':input option:selected').size() > 0) {
                var $dropdownlist = $formRow.find('.jqx-widget.dropdownlist');
                if($dropdownlist.length > 0) {
                    if ($dropdownlist.metadata()['show-checked-count'] == true) {
                        result = $dropdownlist.find('.jqx-item').text();
                    }
                    else {
                        var selectedItems;
                        if($dropdownlist.jqxDropDownList('checkboxes')) {
                            selectedItems = $dropdownlist.jqxDropDownList('getCheckedItems');
                        }
                        else {
                            selectedItems = [$dropdownlist.jqxDropDownList('getSelectedItem')];
                        }
                        if (selectedItems.length > 0) {
                            result = '';
                            for (var i = 0; i < selectedItems.length; i++) {
                                var item = selectedItems[i];
                                if(!item.isGroup && item.value) {
                                    result = result + (result === '' ? '' : ', ') + $.trim(item.label);
                                }
                            }
                            result = trim(result, 100);
                        }
                    }
                }
                else {
                    if ($formRow.find(':input option:not(:selected)').size() > 0) {
                        result = '';
                        $formRow.find(':input option:selected[value!=""]').each(function () {
                            result = result + (result === '' ? '' : ', ') + $.trim($(this).text());
                        });
                        result = trim(result, 100);
                    }
                }
            }
            return result;
        }
    }

    function getTreeValue($formRow) {
        var result = $.trim($formRow.find('.jqx-dropdownlist-content').text());
        return result.length > 0 && result != $formRow.find('.dropdowntree').data('placeholder') ? trim(result, 100) : null;
    }

    function getDateValue($formRow) {
        return getDate($formRow.find('.date-picker'));
    }

    function getDateTimeValue($formRow) {
        return getDate($formRow.find('.date-picker')) + ' ' + $.trim($formRow.find('.time-picker').val());
    }

    function getDateRangeValue($formRow) {
        var dateLeft = getDate($formRow.find('.form-date-range-left'));
        var dateRight = getDate($formRow.find('.form-date-range-right'));
        if(dateLeft && !dateRight) {
            return translate('on or after') + ' ' + dateLeft;
        }
        else if(!dateLeft && dateRight) {
            return translate('on or before') + ' ' + dateRight;
        }
        else if(dateLeft && dateRight) {
            return dateLeft + ' ' + $.trim($formRow.find('.form-date-range-middle').text()) + ' ' + dateRight;
        }
        else {
            return null;
        }
    }

    function getNumberRangeValue($formRow) {
        var minVal = $formRow.find('.form-number-range-left').val();
        var maxVal = $formRow.find('.form-number-range-right').val();
        if(minVal && !maxVal) {
            return translate('greater than or equal to') + ' ' + minVal;
        }
        else if(!minVal && maxVal) {
            return translate('less than or equal to') + ' ' + maxVal;
        }
        else if(minVal && maxVal) {
            if (minVal == maxVal) {
                return minVal;
            }
            
            return minVal + ' ' + $.trim($formRow.find('.form-number-range-middle').text()) + ' ' + maxVal;
        }
        else {
            return null;
        }
    }

    function getDateAndTimeRangeValue($formRow) {
        var dateLeft = getDateTimeValue($formRow.find('.form-datetime').first());
        var dateRight = $.trim($formRow.find('.form-datetime').last().find('.time-picker').val());
        if(dateLeft && dateRight) {
            return dateLeft + ' ' + $.trim($formRow.find('.form-date-range-middle').text()) + ' ' + dateRight;
        }
        else {
            return null;
        }
    }

    function getRadiobuttonsBooleanValue($formRow) {
        var trueLabel = $.trim($formRow.find(':input[value=true]').siblings('label').text());
        var label = getFormRowLabel($formRow);
        // If the true label matches the field label then return true/false
        if(label === trueLabel) {
            return $formRow.find(':input:checked').val() ? translate($formRow.find(':input:checked').val()) : null;
        }
        // else return the actual checkbox labels
        else {
            return $.trim($formRow.find(':input:checked').siblings('label').text());
        }
    }

    function getCheckboxesOrRadiobuttonsValue($formRow) {
        var result = null;
        if($formRow.find(':checkbox:not(:checked),:radio:not(:checked)').size() > 0) {
            result = '';
            $formRow.find(':input:checked:not(.checkAll)').each(function(){
                result = result + (result === '' ? '' : ', ') + $.trim($(this).siblings('label').text());
            });
            result = trim(result, 100);
        }
        return result;
    }

    function getCheckboxValue($formRow) {
        return $formRow.find(':input:checked').size()>0 ? translate('true') : null;
    }

    function getTextValue($formRow) {
        if($formRow.find('.form-telephone-number').size()>0) {
            return $.trim($formRow.find('.form-telephone-number-left').val()) + ' ' + $.trim($formRow.find('.form-telephone-number-right').val());
        }
        else if($formRow.find(':input').size()>0) {
            var result = '';
            $formRow.find(':input:not(.placeholder)').each(function(){
                result = result + (result === '' ? '' : ', ') + $.trim($(this).val());
            });
            result = trim(result, 100);
            return result;
        }
        else {
            return trim($.trim($($formRow.find('.form-text').contents()[0]).text()), 30);
        }
    }

    function trim(text, limit) {
        var result = text;
        if(result.length > limit) {
            result = result.substr(0, limit-2);
            while(result.lastIndexOf(' ') == result.length-1) {
                result = result.substr(0, result.length-1);
            }
            result = result + '...';
        }
        if(result.length > 0) {
            result = '<span title="'+text+'">' + result + '</span>';
        }
        return result;
    }

    function getDate($datepicker) {
        var date = $.trim($datepicker.val());
        return date != $datepicker.attr('placeholder') ? date : null;
    }

    //
    // plugin defaults
    //
    $.fn.collapsibleFilters.defaults = {
        'collapsed': false,
        'show-filters-text': 'Show Filters',
        'hide-filters-text': 'Hide Filters',
        'no-filters-text': 'No filters applied'
    };

})(jQuery);